import React from 'react';
import { Flex } from '@qga/roo-ui/components';
import PulsingLoadingBlock from 'components/PulsingLoadingBlock';

const SkeletonSummary = React.memo(() => {
  return (
    <Flex alignItems="space-between" flexDirection="column" p={2} width="100%">
      <PulsingLoadingBlock height={20} width={160} />
      <Flex mt={2}>
        <PulsingLoadingBlock height={12} mr={2} width={60} />
        <PulsingLoadingBlock height={12} mr={2} width={120} />
        <PulsingLoadingBlock height={12} width={60} />
      </Flex>
    </Flex>
  );
});

SkeletonSummary.displayName = 'SkeletonSummary';

export default SkeletonSummary;
